export var Permissions

export function updatePermission(p) {
   Permissions = p
}
